module.exports = __webpack_public_path__ + "assets/images/21-26fxXr2.jpg";